/*
 * @Author: long
 * @Date: 2022-03-14 16:09:39
 * @LastEditTime: 2023-08-10 14:16:53
 * @LastEditors: long
 * @Description:
 * @FilePath: /website/Users/long/Documents/workspace/portal/src/router/constant-router.js
 *
 */
const router = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/login",
    component: () => import("@/views/Login"),
  },
  {
    path: "/password",

    component: () => import("@/views/Login/password"),
  },

  {
    path: "/home",

    component: () => import("@/views/Home"),
  },
  // 收集服务关闭
  {
    path: "/collection",
    redirect: "/home",
    component: () => import("@/views/Collection"),
  },

  {
    path: "/applyNotice",
    component: () => import("@/views/Apply"),
  },
  {
    path: "/application",
    component: () => import("@/views/Apply/Form"),
  },

  {
    path: "*",
    component: () => import("@/views/ErrorPage"),
  },
];

const collection2026513 = {
  path: "/collection2026513",
  component: () => import("@/views/Collection/Collection2026513"),
};
router.push({
  ...collection2026513,
  ...(window.collection ? {} : { redirect: "/home" }),
});
export default router;
